(function () {
  "use strict";

  angular
    .module('trainerWebApp.directives')
    .directive('mfManageGroups', mfManageGroups);

  function mfManageGroups() {
    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {
        scope.$watch('sidebarContentSrc', function () {
          $(window).trigger('resize');
        });
      }
    }
  }

})();
